export default __webpack_public_path__ + "static/media/no-runbooks.8eec305a.svg";